import { createBrowserRouter } from 'react-router-dom';
import BasicLayout from './layout/basiclayout';
import LandingPage from './pages/landingpage';
import ProductPage from './pages/productpage';
import CategoryPage from './pages/categorypage';
import RecentlyAddedPage from './pages/recentlyaddedpage';
import BrandPage from './pages/brandpage';
import BrandProductPage from './pages/brandproductpage';
import BrandFormTable from './pages/addBrand';
import ProductFormWithVariants from './pages/addproduct';
import AboutUs from './pages/aboutuspage';
import ContactUs from './pages/contactuspage';
import MultiFileUploader from './pages/addbulkproduct';
const Route = createBrowserRouter([
    {
        path:'/',
        element:<BasicLayout/>,
        children:[
            {index:true,element:<LandingPage/>},
            {path:'/product/:product',element:<ProductPage/>},
            {path:'/addbrand',element:<BrandFormTable/>},
            {path:'/addbulk',element:<MultiFileUploader/>},
            {path:'/addproduct',element:<ProductFormWithVariants/>},
            {path:'/category/:category',element:<CategoryPage/>},
            {path:'/recently-added',element:<RecentlyAddedPage/>},
            {path:'/brand' ,
                children:[
                    {index:true,element:<BrandPage/>},
                    {path:':brandname',element:<BrandProductPage/>}
                ]
            },
            {path:'/aboutus',element:<AboutUs/>},
            {path:'/contactus',element:<ContactUs/>}
        ]
    }
])

export default Route